export default __webpack_public_path__ + "static/media/facebook.7cb8783a.svg";